
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4QBabej2MYhL4U307StqPo03wmDbZy6K4BshQlkavR0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/index.vue?macro=true";
import { default as elasticsearchgS5Rbw5Sfic_xjzKVCt_axH_16aTPnHyRQAJ5azu1w0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/elasticsearch.vue?macro=true";
import { default as operationsZiflYm3U5Jy7pemvl1ZMoEZgjITZjJr36PjwfXed55UMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/advanced/operations.vue?macro=true";
import { default as indexIkHnYUB_OWxZ7yDICmZSI6YWbZAMplJHyJhT2ou34acMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/advanced/algorithm-annotation/index.vue?macro=true";
import { default as opportunity_45score_45benchmarktGxGwWYEdkKX_MmI3JlSMNguhr2g2sv4IZp1boJqMmgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/advanced/opportunity-score-benchmark.vue?macro=true";
import { default as _91advancedSearchId_93fUBeye4xUejDlSHJjeLeKzgGp5szaI7eHQWXaHQ1yHIMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/advanced/algorithm-annotation/[annotationSessionId]/[advancedSearchId].vue?macro=true";
import { default as adminZ3LwYige33aSCg7OjHCi8RNAHChnF1kunhUKz3rKxqwMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin.vue?macro=true";
import { default as index7qwB9dFyR5ZjDtk9T2EsBi082RFB44g5j282WFt8dakMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/index.vue?macro=true";
import { default as indextOYp_jdhq7spq0MzbqzysMVxDgu8Hf9mm1WyMesQO1sMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/advanced/index.vue?macro=true";
import { default as _91step_9325novPhqD40e5kmJq_UT5s5y_iZki8Oyuj7jQIrXpuQMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/advanced/[briefId]/[step].vue?macro=true";
import { default as _91briefId_93RkC94SaqaLDG0DQHslihVVPH0y5MDHrr2ZN4uWaYPeoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/advanced/[briefId].vue?macro=true";
import { default as advancedL_hzsrvZMW43kmNG_trnOdKWU1SNpPIpfPhrNr2fiCEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/advanced.vue?macro=true";
import { default as dispatchf__LyeC_WzJYNS_nQf4xhiYhQZNTa9I_mJOGEANS4r4Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/dispatch.vue?macro=true";
import { default as previewHwq_zF_rBRfL2dpwuWiq9n8MRyqCRWl_XcB2_bnl0dIMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-utils/nuxt-prismic-module/src/runtime/pages/preview.vue?macro=true";
export default [
  {
    name: adminZ3LwYige33aSCg7OjHCi8RNAHChnF1kunhUKz3rKxqwMeta?.name,
    path: "/s/admin",
    meta: { ...(adminZ3LwYige33aSCg7OjHCi8RNAHChnF1kunhUKz3rKxqwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin.vue"),
    children: [
  {
    name: "s-admin",
    path: "",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/index.vue")
  },
  {
    name: "s-admin-elasticsearch",
    path: "elasticsearch",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/elasticsearch.vue")
  },
  {
    name: "s-admin-advanced-operations",
    path: "advanced/operations",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/advanced/operations.vue")
  },
  {
    name: "s-admin-advanced-algorithm-annotation",
    path: "advanced/algorithm-annotation",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/advanced/algorithm-annotation/index.vue")
  },
  {
    name: "s-admin-advanced-opportunity-score-benchmark",
    path: "advanced/opportunity-score-benchmark",
    meta: { ...(opportunity_45score_45benchmarktGxGwWYEdkKX_MmI3JlSMNguhr2g2sv4IZp1boJqMmgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/advanced/opportunity-score-benchmark.vue")
  },
  {
    name: "s-admin-advanced-algorithm-annotation-annotationSessionId-advancedSearchId",
    path: "advanced/algorithm-annotation/:annotationSessionId()/:advancedSearchId()",
    meta: _91advancedSearchId_93fUBeye4xUejDlSHJjeLeKzgGp5szaI7eHQWXaHQ1yHIMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/admin/advanced/algorithm-annotation/[annotationSessionId]/[advancedSearchId].vue")
  }
]
  },
  {
    name: "s",
    path: "/s",
    meta: index7qwB9dFyR5ZjDtk9T2EsBi082RFB44g5j282WFt8dakMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/index.vue")
  },
  {
    name: advancedL_hzsrvZMW43kmNG_trnOdKWU1SNpPIpfPhrNr2fiCEMeta?.name,
    path: "/s/advanced",
    meta: advancedL_hzsrvZMW43kmNG_trnOdKWU1SNpPIpfPhrNr2fiCEMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/advanced.vue"),
    children: [
  {
    name: "s-advanced",
    path: "",
    meta: indextOYp_jdhq7spq0MzbqzysMVxDgu8Hf9mm1WyMesQO1sMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/advanced/index.vue")
  },
  {
    name: "s-advanced-briefId",
    path: ":briefId()",
    meta: _91briefId_93RkC94SaqaLDG0DQHslihVVPH0y5MDHrr2ZN4uWaYPeoMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/advanced/[briefId].vue"),
    children: [
  {
    name: "s-advanced-briefId-step",
    path: ":step()",
    meta: _91step_9325novPhqD40e5kmJq_UT5s5y_iZki8Oyuj7jQIrXpuQMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/advanced/[briefId]/[step].vue")
  }
]
  }
]
  },
  {
    name: "s-dispatch",
    path: "/s/dispatch",
    meta: dispatchf__LyeC_WzJYNS_nQf4xhiYhQZNTa9I_mJOGEANS4r4Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/hopsearch/search-front/app/pages/s/dispatch.vue")
  },
  {
    name: "preview-page",
    path: "/s/preview",
    meta: {"layout":false,"middleware":[],"cookieVerifierSkip":true},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-utils/nuxt-prismic-module/src/runtime/pages/preview.vue")
  }
]